import {
	AfterViewInit,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	Output
} from '@angular/core';

import { ConfirmationDialogAngularComponent } from './ConfirmationDialogAngular.Component';
import { DialogService } from './Dialog.Service';

/**
 *Deprecated: Use DialogService.openConfirmationDialog instead
 */
@Component({
	selector: 'vb-confirmation-dialog',
	host: {
		style: 'display: none'
	},
	template: `
		<ng-content #content>
		</ng-content>
	`,
	standalone: false
})
export class VbConfirmationDialogComponent implements AfterViewInit {
	@Input() public actionText: string;
	@Input() public cancelText: string;
	@Input() public headerIconClass: string;
	@Input() public headerIconType: string;
	@Input() public message: string;
	@Input() public rememberText: string;
	@Input() public secondaryActionText: string;
	@Input() public themed: boolean;
	@Input() public title: string;

	@Output() public onReady: EventEmitter<void> = new EventEmitter();

	constructor(
		private elem: ElementRef<HTMLElement>,
		private Dialog: DialogService
	) {}

	public ngAfterViewInit(): void {
		this.onReady.emit();
	}

	public open(): ConfirmationDialogAngularComponent {
		return this.Dialog.openConfirmationDialog({
			actionText: this.actionText,
			cancelText: this.cancelText,
			headerIconClass: this.headerIconClass,
			headerIconType: this.headerIconType,
			htmlMessage: this.elem.nativeElement.innerHTML.trim() || undefined,
			message: this.message,
			rememberText: this.rememberText,
			secondaryActionText: this.secondaryActionText,
			themed: this.themed,
			title: this.title
		});
	}
}
